<template>
  <div class="content">
    <h1 class="has-text-centered">Einheitenvorsätze (SI-Präfixe)</h1>
    <div class="box">
    <p>
      Einheitenvorsätze (SI-Präfixe) sind <b>Multiplikatoren</b> mithilfe derer man <b>große und kleine Zahlen einfacher darstellen</b> kann.
      Sie werden vor <router-link :to="{name: 'tables-si-units'}">SI-Einheiten</router-link> gesetzt und <b>basieren auf Zehnerpotenzen mit ganzzahligen Exponenten</b>.<br>
      Die benutzten Symbole für Einheitenvorsätze sind <b>international einheitlich</b>.<br><br>
      Beispiele:<br>
      <ul>
        <li>5.000 W <i class="fas fa-arrow-right"></i> 5 kW</li>
        <li>0,00032 A <i class="fas fa-arrow-right"></i> 320 &#181;A</li>
        <li>32.000 V <i class="fas fa-arrow-right"></i> 32 kV</li>
      </ul>
    </p>
    <div class="content has-overflow-x-auto">
      <table class="table is-hoverable is-striped is-fullwidth has-nowrap-text">
        <thead>
          <tr>
            <th>Vorsatz</th>
            <th>Abkürzung</th>
            <th colspan="2">Multiplikator</th>
            <th>Beispiel mit Volt</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Tera</td>
            <td>T</td>
            <td>10<sup>12</sup></td>
            <td>1.000.000.000.000</td>
            <td>TV (Teravolt)</td>
          </tr>
          <tr>
            <td>Giga</td>
            <td>G</td>
            <td>10<sup>9</sup></td>
            <td>1.000.000.000</td>
            <td>GV (Gigavolt)</td>
          </tr>
          <tr>
            <td>Mega</td>
            <td>M</td>
            <td>10<sup>6</sup></td>
            <td>1.000.000</td>
            <td>MV (Megavolt)</td>
          </tr>
          <tr>
            <td>Kilo</td>
            <td>k</td>
            <td>10<sup>3</sup></td>
            <td>1.000</td>
            <td>kV (Kilovolt)</td>
          </tr>
          <tr>
            <td>ohne Vorsatz</td>
            <td></td>
            <td>10<sup>0</sup></td>
            <td>1</td>
            <td>V (Volt)</td>
          </tr>
          <tr>
            <td>Milli</td>
            <td>m</td>
            <td>10<sup>-3</sup></td>
            <td>0,001</td>
            <td>mV (Millivolt)</td>
          </tr>
          <tr>
            <td>Mikro</td>
            <td>&#181;</td>
            <td>10<sup>-6</sup></td>
            <td>0,000.001</td>
            <td>&#181;V (Mikrovolt)</td>
          </tr>
          <tr>
            <td>Nano</td>
            <td>n</td>
            <td>10<sup>-9</sup></td>
            <td>0,000.000.001</td>
            <td>nV (Nanovolt)</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      Es gibt noch einige <b>weitere Einheitenvorsätze</b>, aber die hier gelisteten sind die gängigsten in der Elektrotechnik.<br>
      Eine <b>umfangreichere Tabelle</b> findest du auf <a target="_blank" href="https://de.wikipedia.org/wiki/Vors%C3%A4tze_f%C3%BCr_Ma%C3%9Feinheiten">Wikipedia</a>.
    </p>
  </div>
  </div>
</template>

<script>
export default {
  name: 'tables-units-prefixes',
  metaInfo: {
    title: 'Einheitenvorsätze Tabelle | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Einheitenvorsätze sind Multiplikatoren mithilfe derer man große und kleine Zahlen einfacher darstellen kann.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'tables' })
  }
}
</script>
